/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptLadderChallengeResponse,
  ApiError,
  CompleteLadderChallengeBody,
  CompleteLadderChallengeResponse,
  CreateLadderChallengeBody,
  CreateLadderChallengeResponse,
  DeclineLadderChallengeBody,
  DeclineLadderChallengeResponse,
  ForfeitLadderChallengeBody,
  ForfeitLadderChallengeResponse,
  GetLadderChallengesResponse,
  GetLadderChallengesSort,
  LadderChallengeStatus,
  SortOrder,
} from '../models/index';
import {
    AcceptLadderChallengeResponseFromJSON,
    AcceptLadderChallengeResponseToJSON,
    ApiErrorFromJSON,
    ApiErrorToJSON,
    CompleteLadderChallengeBodyFromJSON,
    CompleteLadderChallengeBodyToJSON,
    CompleteLadderChallengeResponseFromJSON,
    CompleteLadderChallengeResponseToJSON,
    CreateLadderChallengeBodyFromJSON,
    CreateLadderChallengeBodyToJSON,
    CreateLadderChallengeResponseFromJSON,
    CreateLadderChallengeResponseToJSON,
    DeclineLadderChallengeBodyFromJSON,
    DeclineLadderChallengeBodyToJSON,
    DeclineLadderChallengeResponseFromJSON,
    DeclineLadderChallengeResponseToJSON,
    ForfeitLadderChallengeBodyFromJSON,
    ForfeitLadderChallengeBodyToJSON,
    ForfeitLadderChallengeResponseFromJSON,
    ForfeitLadderChallengeResponseToJSON,
    GetLadderChallengesResponseFromJSON,
    GetLadderChallengesResponseToJSON,
    GetLadderChallengesSortFromJSON,
    GetLadderChallengesSortToJSON,
    LadderChallengeStatusFromJSON,
    LadderChallengeStatusToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/index';

export interface CreateLaddersIdChallengesRequest {
    id: string;
    createLadderChallengeBody: CreateLadderChallengeBody;
}

export interface GetLaddersIdChallengesRequest {
    id: string;
    sort?: GetLadderChallengesSort;
    order?: SortOrder;
    status?: LadderChallengeStatus;
    participantId?: string;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface UpdateLadderChallengesIdAcceptRequest {
    id: string;
    body?: object;
}

export interface UpdateLadderChallengesIdCompleteRequest {
    id: string;
    completeLadderChallengeBody: CompleteLadderChallengeBody;
}

export interface UpdateLadderChallengesIdDeclineRequest {
    id: string;
    declineLadderChallengeBody?: DeclineLadderChallengeBody;
}

export interface UpdateLadderChallengesIdForfeitRequest {
    id: string;
    forfeitLadderChallengeBody?: ForfeitLadderChallengeBody;
}

/**
 * LadderChallengesApi - interface
 * 
 * @export
 * @interface LadderChallengesApiInterface
 */
export interface LadderChallengesApiInterface {
    /**
     * Issue a challenge to another participant in the ladder. Challenger must be lower-ranked (higher rank number) than defender. 
     * @summary Create a new ladder challenge
     * @param {string} id 
     * @param {CreateLadderChallengeBody} createLadderChallengeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LadderChallengesApiInterface
     */
    createLaddersIdChallengesRaw(requestParameters: CreateLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLadderChallengeResponse>>;

    /**
     * Issue a challenge to another participant in the ladder. Challenger must be lower-ranked (higher rank number) than defender. 
     * Create a new ladder challenge
     */
    createLaddersIdChallenges(requestParameters: CreateLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLadderChallengeResponse>;

    /**
     * Retrieve a paginated list of challenges for a specific ladder with optional filtering by status or participant.
     * @summary Get ladder challenges
     * @param {string} id Ladder ID
     * @param {GetLadderChallengesSort} [sort] Field to sort results by
     * @param {SortOrder} [order] Sort order (asc or desc)
     * @param {LadderChallengeStatus} [status] Filter by challenge status
     * @param {string} [participantId] Filter by participant (as challenger or defender)
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LadderChallengesApiInterface
     */
    getLaddersIdChallengesRaw(requestParameters: GetLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderChallengesResponse>>;

    /**
     * Retrieve a paginated list of challenges for a specific ladder with optional filtering by status or participant.
     * Get ladder challenges
     */
    getLaddersIdChallenges(requestParameters: GetLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderChallengesResponse>;

    /**
     * Defender accepts a pending challenge. Creates a Match document for gameplay tracking. The Match handles the gameplay lifecycle (IN_PROGRESS, scores, disputes, completion). 
     * @summary Accept a ladder challenge
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LadderChallengesApiInterface
     */
    updateLadderChallengesIdAcceptRaw(requestParameters: UpdateLadderChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptLadderChallengeResponse>>;

    /**
     * Defender accepts a pending challenge. Creates a Match document for gameplay tracking. The Match handles the gameplay lifecycle (IN_PROGRESS, scores, disputes, completion). 
     * Accept a ladder challenge
     */
    updateLadderChallengesIdAccept(requestParameters: UpdateLadderChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptLadderChallengeResponse>;

    /**
     * Admin endpoint to manually complete a ladder challenge and its associated Match. Calculates rating changes, updates participant stats, and handles rank swapping. 
     * @summary Admin-complete a ladder challenge
     * @param {string} id 
     * @param {CompleteLadderChallengeBody} completeLadderChallengeBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LadderChallengesApiInterface
     */
    updateLadderChallengesIdCompleteRaw(requestParameters: UpdateLadderChallengesIdCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteLadderChallengeResponse>>;

    /**
     * Admin endpoint to manually complete a ladder challenge and its associated Match. Calculates rating changes, updates participant stats, and handles rank swapping. 
     * Admin-complete a ladder challenge
     */
    updateLadderChallengesIdComplete(requestParameters: UpdateLadderChallengesIdCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteLadderChallengeResponse>;

    /**
     * Allows the defender to decline a pending ladder challenge.
     * @summary Decline a ladder challenge
     * @param {string} id 
     * @param {DeclineLadderChallengeBody} [declineLadderChallengeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LadderChallengesApiInterface
     */
    updateLadderChallengesIdDeclineRaw(requestParameters: UpdateLadderChallengesIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeclineLadderChallengeResponse>>;

    /**
     * Allows the defender to decline a pending ladder challenge.
     * Decline a ladder challenge
     */
    updateLadderChallengesIdDecline(requestParameters: UpdateLadderChallengesIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeclineLadderChallengeResponse>;

    /**
     * Allows a participant to forfeit an accepted ladder challenge. The forfeiter receives a loss, the opponent receives a win. If defender forfeits to challenger, ranks are swapped. No rating changes occur on forfeit. 
     * @summary Forfeit a ladder challenge
     * @param {string} id 
     * @param {ForfeitLadderChallengeBody} [forfeitLadderChallengeBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LadderChallengesApiInterface
     */
    updateLadderChallengesIdForfeitRaw(requestParameters: UpdateLadderChallengesIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForfeitLadderChallengeResponse>>;

    /**
     * Allows a participant to forfeit an accepted ladder challenge. The forfeiter receives a loss, the opponent receives a win. If defender forfeits to challenger, ranks are swapped. No rating changes occur on forfeit. 
     * Forfeit a ladder challenge
     */
    updateLadderChallengesIdForfeit(requestParameters: UpdateLadderChallengesIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForfeitLadderChallengeResponse>;

}

/**
 * 
 */
export class LadderChallengesApi extends runtime.BaseAPI implements LadderChallengesApiInterface {

    /**
     * Issue a challenge to another participant in the ladder. Challenger must be lower-ranked (higher rank number) than defender. 
     * Create a new ladder challenge
     */
    async createLaddersIdChallengesRaw(requestParameters: CreateLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreateLadderChallengeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createLaddersIdChallenges().'
            );
        }

        if (requestParameters['createLadderChallengeBody'] == null) {
            throw new runtime.RequiredError(
                'createLadderChallengeBody',
                'Required parameter "createLadderChallengeBody" was null or undefined when calling createLaddersIdChallenges().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladders/{id}/challenges`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateLadderChallengeBodyToJSON(requestParameters['createLadderChallengeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreateLadderChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Issue a challenge to another participant in the ladder. Challenger must be lower-ranked (higher rank number) than defender. 
     * Create a new ladder challenge
     */
    async createLaddersIdChallenges(requestParameters: CreateLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreateLadderChallengeResponse> {
        const response = await this.createLaddersIdChallengesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve a paginated list of challenges for a specific ladder with optional filtering by status or participant.
     * Get ladder challenges
     */
    async getLaddersIdChallengesRaw(requestParameters: GetLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLadderChallengesResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getLaddersIdChallenges().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['participantId'] != null) {
            queryParameters['participantId'] = requestParameters['participantId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/ladders/{id}/challenges`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLadderChallengesResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve a paginated list of challenges for a specific ladder with optional filtering by status or participant.
     * Get ladder challenges
     */
    async getLaddersIdChallenges(requestParameters: GetLaddersIdChallengesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLadderChallengesResponse> {
        const response = await this.getLaddersIdChallengesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Defender accepts a pending challenge. Creates a Match document for gameplay tracking. The Match handles the gameplay lifecycle (IN_PROGRESS, scores, disputes, completion). 
     * Accept a ladder challenge
     */
    async updateLadderChallengesIdAcceptRaw(requestParameters: UpdateLadderChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AcceptLadderChallengeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLadderChallengesIdAccept().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladder-challenges/{id}/accept`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AcceptLadderChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Defender accepts a pending challenge. Creates a Match document for gameplay tracking. The Match handles the gameplay lifecycle (IN_PROGRESS, scores, disputes, completion). 
     * Accept a ladder challenge
     */
    async updateLadderChallengesIdAccept(requestParameters: UpdateLadderChallengesIdAcceptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AcceptLadderChallengeResponse> {
        const response = await this.updateLadderChallengesIdAcceptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Admin endpoint to manually complete a ladder challenge and its associated Match. Calculates rating changes, updates participant stats, and handles rank swapping. 
     * Admin-complete a ladder challenge
     */
    async updateLadderChallengesIdCompleteRaw(requestParameters: UpdateLadderChallengesIdCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CompleteLadderChallengeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLadderChallengesIdComplete().'
            );
        }

        if (requestParameters['completeLadderChallengeBody'] == null) {
            throw new runtime.RequiredError(
                'completeLadderChallengeBody',
                'Required parameter "completeLadderChallengeBody" was null or undefined when calling updateLadderChallengesIdComplete().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladder-challenges/{id}/complete`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: CompleteLadderChallengeBodyToJSON(requestParameters['completeLadderChallengeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CompleteLadderChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Admin endpoint to manually complete a ladder challenge and its associated Match. Calculates rating changes, updates participant stats, and handles rank swapping. 
     * Admin-complete a ladder challenge
     */
    async updateLadderChallengesIdComplete(requestParameters: UpdateLadderChallengesIdCompleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CompleteLadderChallengeResponse> {
        const response = await this.updateLadderChallengesIdCompleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows the defender to decline a pending ladder challenge.
     * Decline a ladder challenge
     */
    async updateLadderChallengesIdDeclineRaw(requestParameters: UpdateLadderChallengesIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeclineLadderChallengeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLadderChallengesIdDecline().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladder-challenges/{id}/decline`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DeclineLadderChallengeBodyToJSON(requestParameters['declineLadderChallengeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeclineLadderChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Allows the defender to decline a pending ladder challenge.
     * Decline a ladder challenge
     */
    async updateLadderChallengesIdDecline(requestParameters: UpdateLadderChallengesIdDeclineRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeclineLadderChallengeResponse> {
        const response = await this.updateLadderChallengesIdDeclineRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Allows a participant to forfeit an accepted ladder challenge. The forfeiter receives a loss, the opponent receives a win. If defender forfeits to challenger, ranks are swapped. No rating changes occur on forfeit. 
     * Forfeit a ladder challenge
     */
    async updateLadderChallengesIdForfeitRaw(requestParameters: UpdateLadderChallengesIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ForfeitLadderChallengeResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateLadderChallengesIdForfeit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/ladder-challenges/{id}/forfeit`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ForfeitLadderChallengeBodyToJSON(requestParameters['forfeitLadderChallengeBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ForfeitLadderChallengeResponseFromJSON(jsonValue));
    }

    /**
     * Allows a participant to forfeit an accepted ladder challenge. The forfeiter receives a loss, the opponent receives a win. If defender forfeits to challenger, ranks are swapped. No rating changes occur on forfeit. 
     * Forfeit a ladder challenge
     */
    async updateLadderChallengesIdForfeit(requestParameters: UpdateLadderChallengesIdForfeitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ForfeitLadderChallengeResponse> {
        const response = await this.updateLadderChallengesIdForfeitRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
